import { authHeader, handleResponse } from '../helpers';
export const dashboardService = {
    fetchData,
    fecthLoyalityPoint,
    TopfecthLoyalityPoint
};

function fetchData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}Dashboard/GetDashboardData`, requestOptions)
    .then(handleResponse);
    
}
function fecthLoyalityPoint(data){
    const requestOptions ={
        method :'POST',
        headers : authHeader(),
        body : JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserLoyalityLogRpt/GetUserLoyalityLogReport`, requestOptions)
    .then(handleResponse);
}

function TopfecthLoyalityPoint(data){ 
    const requestOptions ={
        method :'POST',
        headers : authHeader(),
        body : JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}UserLoyalityLogRpt/GetTopLoyalityAchievers`, requestOptions)
    .then(handleResponse);
}